var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-confirm',{attrs:{"dialog":_vm.dialogModal,"title":"customFieldDialogTitle","message":"customFieldDialogDescription"},on:{"cancel":_vm.cancelDeleteCustomField,"confirm":_vm.deleteCustomField}})}
var staticRenderFns = []

export { render, staticRenderFns }